import { createSlice } from "@reduxjs/toolkit";
import {
    fetchAllProductsThunk,
    toggleMultipleProductsThunk,
    toggleProductThunk
} from "./allProductsThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    hasMore: true,
    error: null,
    page: 1
};

export const allProductsSlice = createSlice({
    name: "all-products",
    initialState,
    reducers: {
        hydate: (state, action) => {
            const { content, totalElements, totalPages, last } = action.payload;
            state.items = content;
            state.total = totalElements;
            state.totalPages = totalPages;
            state.hasMore = !last;
        },
        removeItem: (state, action) => {
            const productId = action.payload;
            state.items = state.items.filter((e) => e.id !== productId);
            state.total = state.total - 1;
        },
        removeItems: (state, action) => {
            const productIds = action.payload;
            state.items = state.items.filter((e) => !productIds.includes(e.id));
            state.total = state.total - productIds.length;
        },
        resetAllProducts: (state) => {
            state.items = [];
            state.total = 0;
            state.totalPages = 0;
            state.page = 1;
            state.hasMore = true;
            state.error = null;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllProductsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllProductsThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                const products = data.content.map((product) => {
                    return {
                        ...product,
                        isEnabled:
                            product.productVariantDTO &&
                            product.productVariantDTO.length !== 0 &&
                            product.productVariantDTO.some((e) => e.enable)
                    };
                });
                state.items = products;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
            })
            .addCase(fetchAllProductsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Toggle single product
            .addCase(toggleProductThunk.fulfilled, (state, action) => {
                const { productId, action: toggleAction } = action.payload;
                const product = state.items.find((p) => p.id === productId);
                if (product) {
                    product.isEnabled = toggleAction;

                    if (product.productVariantDTO?.length) {
                        product.productVariantDTO.forEach((variant) => {
                            variant.enable = toggleAction;
                        });
                    }
                }
            })

            // Toggle multiple products
            .addCase(toggleMultipleProductsThunk.fulfilled, (state, action) => {
                action.payload.forEach(({ productId, action: toggleAction }) => {
                    const product = state.items.find((p) => p.id === productId);
                    if (product) {
                        product.isEnabled = toggleAction;

                        if (product.productVariantDTO?.length) {
                            product.productVariantDTO.forEach((variant) => {
                                variant.enable = toggleAction;
                            });
                        }
                    }
                });
            });
    }
});

export const { hydrate, resetAllProducts, removeItem, removeItems, setPage } =
    allProductsSlice.actions;
export default allProductsSlice.reducer;
